module.exports = __webpack_public_path__ + "img/2_9.09b4a064.png";